<div class="banner-about">

    <div class="title-about"> << TITÁN APP >></div>
    <div class="title-about-name"> Aplicación de <br/>
       <span class="title-about-marketing"> marketing Digital</span></div>

       <button type="button" class="btn btn-download" (click)="downloadToApp()"><span class="material-icons">adb</span><span class="download">Descargala</span></button>

</div>

<div class="about-app">
  <div class="container" >
    <div class="about-app-part1">
        <div class="about-app-title">
            Productos y contenidos
        </div>
        <div class="about-app-text">
            Conoce todo el contenido que tenemos disponible en nuestra plataforma, así podrás generar oportunidades de venta recomendándoles contenidos edificantes a tu público.
        </div>
        <div class="about-app-title">
            Tus contactos en un solo lugar
        </div>
        <div class="about-app-text">
            Crea, perfila y convierte tus contactos en posibles clientes. Aquí podrás hacer toda la gestión relacionada con tu público objetivo.  </div>

        </div>
    <div class="about-app-img">
        <img src="{{urlBlobStorage}}about-the-titan-app/Images/Celular.webp" class="logo-titanes img-about-destok" alt="logo titanes" />
        <img src="{{urlBlobStorage}}about-the-titan-app/Images/Celular.webp" class="logo-titanes img-about-mobil" alt="logo titanes" />
    </div>
    <div class="about-app-part2">
        <div class="about-app-title">
            Tus ganancias
        </div>
        <div class="about-app-text">
            Este es tu bolsillo. Transfiere y obtén extractos e informes acerca del dinero que dispones y de los movimientos que has hecho.    </div>
        <div class="about-app-title">
            Calendario de actividades
        </div>
        <div class="about-app-text">
            Lleva el control de tu cronograma y mantente informado sobre los nuevos contenidos, las nuevas oportunidades de venta y novedades de Gran Titán. </div>


    </div>
  </div>
  <button type="button" class="btn btn-double-arrow" (click)="downloadToApp()"><span class="material-icons">keyboard_double_arrow_down</span></button>
</div>

<div class="section-app">
    <div class="container" >
        <div class="section-app-title" >Secciones de la aplicación </div>

        <div class="section-app-share">
            <div class="section-app-img">
                <img src="{{urlBlobStorage}}about-the-titan-app/Images/Compartir.webp" class="logo-titanes img-about-app-destok" alt="logo titanes" />
            </div>

            <div class="section-app-text">
                <div class="section-app-text-title"><div class="section-app-text-title-ico"><img src="{{urlBlobStorage}}about-the-titan-app/Icos/Share.svg" alt=" "></div>Compartir</div>
                <div class="section-app-text-description">Desde esta sección podrás compartirle a tu público contenido de interés.</div>
                <div class="section-app-share-btn">  
                    <button type="button" class="btn btn-download-app" (click)="downloadToApp()"><span class="material-icons">adb</span><span class="download">Descarga la Titán App</span></button>
                    <button type="button" class="btn btn-about-share" (click)="downloadToApp()">Aprende a compartir contenido</button>
                </div>
            </div>
        </div>
        <div class="section-app-share memory-jogger">
            <div class="section-app-img">
                <img src="{{urlBlobStorage}}about-the-titan-app/Images/Memory-jogger.webp" class="logo-titanes img-about-app-destok" alt="logo titanes" />
            </div>
            <div class="section-app-text">
                <div class="section-app-text-title"><div class="section-app-text-title-ico"><img src="{{urlBlobStorage}}about-the-titan-app/Icos/memmory-blue.svg" alt=" "></div>Memory Jogger</div>
                <div class="section-app-text-description">En esta sección encontrarás un conjunto de preguntas que te ayudarán a perfilar a tu público.</div>
                <div class="section-app-share-btn">  
                    <button type="button" class="btn btn-download-app" (click)="downloadToApp()"><span class="material-icons">adb</span><span class="download">Descarga la Titán App</span></button>
                    <button type="button" class="btn btn-about-share" (click)="downloadToApp()">Aprende a usar el Memory Jogger</button>
                </div>
            </div>
        </div>

        <div class="section-app-share">
            <div class="section-app-img">
                <img src="{{urlBlobStorage}}about-the-titan-app/Images/Mis-contactos.webp" class="logo-titanes img-about-app-destok" alt="logo titanes" />
            </div>

            <div class="section-app-text">
                <div class="section-app-text-title"><div class="section-app-text-title-ico"><img src="{{urlBlobStorage}}about-the-titan-app/Icos/Contacts.svg" alt="Mis contactos Titán App"></div>Mis contactos</div>
                <div class="section-app-text-description">Crea, importa, filtra y encuentra información, como parentesco, intereses, edad, y demás datos que te ayudarán a identificar a tu público.</div>
                <div class="section-app-share-btn">  
                    <button type="button" class="btn btn-download-app" (click)="downloadToApp()"><span class="material-icons">adb</span><span class="download">Descarga la Titán App</span></button>
                    <button type="button" class="btn btn-about-share" (click)="downloadToApp()">Aprende a gestionar tus contactos</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="learn-app">
    <div class="container" >
        <div class="learn-app-box1"> 
            <div class="learn-title">Aprende a usar la Titán App</div> 
            <div class="learn-text">Una serie de videos tutoriales creados para ti.</div> 
            <button type="button" class="btn btn-access-videos">Accede a los videos</button>
        </div>
      <div class="learn-app-box2"> 
        <img src="{{urlBlobStorage}}about-the-titan-app/Images/Grupo-2885.webp" alt="Aprende a usar la Titán App">
      </div>
    </div>
</div> 

<div class="join-up">
    <div class="container" >
        <div class="join-up-box1"> 
            <img src="{{urlBlobStorage}}about-the-titan-app/Images/Unete-a-la-comunidad-de-titanes.webp" alt="Aprende a usar la Titán App">
        </div>
      <div class="join-up-box2"> 
            <div class="join-up-title">Únete a nuestro programa, aprende <span class="join-up-text">Marketing Digital</span> y Gana dinero.</div> 
          
            <button type="button" class="btn btn-join-up">Conviértete en Titán</button>
      </div>
    </div>
</div> 